import { updateArrInStore } from '@/store/storeHelpers';
import clone from 'lodash/clone';
import isEqual from 'lodash/isEqual';

export default {
  setMessages: (state, messages) => {
    state.messages = messages;
  },
  setMessagesLoaded: (state, loading) => {
    state.messagesLoaded = loading;
  },
  setMessageLoading: (state, loading) => {
    state.messageLoading = loading;
  },
  updateMessageInList: (state, message) => {
    updateArrInStore(state, message, 'messages');
  },
  setThreads: (state, threads) => {
    const previous = new Map((state.threads || []).map((t) => [t.id, t]));
    state.threads = threads.map((thread) => {
      const next = {
        ...thread,
        occupied: false,
        selected: false,
      };
      // Reuses an unchanged thread's object so its row does not re-render.
      const current = previous.get(thread.id);
      return isEqual(current, next) ? current : next;
    });
  },
  setThreadsScrollPosition: (state, scrollPosition) => {
    state.threadsScrollPosition = scrollPosition;
  },
  setThreadsFilters: (state, filters) => {
    const objFilters = clone(state.threadsFilters);
    for (let key in filters) {
      if (filters[key]) {
        objFilters[key] = filters[key];
      } else {
        delete objFilters[key];
      }
    }
    state.threadsFilters = objFilters;
  },
  setThreadsLoading: (state, loading) => {
    state.threadsLoading = loading;
  },
  setThreadsFiltering: (state, filtering) => {
    state.threadsFiltering = filtering;
  },
  setAfterHoursCount: (state, count) => {
    state.afterHoursCount = count;
  },
  updateThread: (state, { id, thread_id, data }) => {
    let threads = state.threads || [];
    let threadIdx = threads.findIndex((thread) => {
      return thread.id === id || (thread_id && thread.thread_id === thread_id);
    });
    if (threadIdx !== -1) {
      threads[threadIdx] = Object.assign(threads[threadIdx], data);
    }
  },
  updateThreadPerson: (state, thread) => {
    let threads = state.threads || [];
    threads.forEach((t) => {
      if (t.type_id === thread.type_id) {
        t.name = thread.name;
      }
    });
  },
  setMessagesSchemas: (state, schemas) => {
    state.messagesSchemas = schemas;
  },
  setMessagesSchemasLoaded: (state) => {
    state.messagesSchemasLoaded = true;
  },
  setPortalRecipients: (state, recipients) => {
    state.portalRecipients = recipients;
    state.portalRecipientsLoaded = true;
  },
  setConversation: (state, conversation = []) => {
    state.conversation = conversation;
  },
  setConversationLoading: (state, loading = false) => {
    state.conversationLoading = loading;
  },
  removeConversationMessage: (state, id) => {
    state.conversation = state.conversation.filter(
      (m) => m.id !== id && m.tempId !== id
    );
  },
  updateConversation: (state, message) => {
    const messageIdx = state.conversation.findIndex(({ id, tempId }) => {
      return id === message.id || (message.tempId && message.tempId === tempId);
    });

    if (messageIdx > -1) {
      const mergedMessage = {
        ...state.conversation[messageIdx],
        ...message,
        useTransition: false,
      };
      state.conversation.splice(messageIdx, 1, mergedMessage);
    } else {
      state.conversation.push(message);
    }
  },
};
